export default __webpack_public_path__ + "5ea4bd8b4d11c7b585209966e92c5503.png";